import { SxProps, Theme } from '@mui/material';

export const userButtonStyles: SxProps<Theme> = {
  backgroundColor: 'var(--paper)',
  padding: 0.2,
};

export const menuItemLayout = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  px: 2,
  py: 1,
};
